import { useMemo } from 'react';

import useForm from '../utils/useForm';
import LoanService from '../../services/LoanService';

const useInsuranceDocumentForm = (onSubmit, loanId) => {
  const submitHandler = (formValues, actions) => {
    onSubmit(formValues);
    actions.resetForm();
  };

  const fields = useMemo(
    () => [
      {
        title: 'Document',
        isTitleHidden: true,
        fields: [
          {
            title: 'Document',
            name: 'document_id',
            type: 'fetchableSelect',
            fetchOptions: {
              key: ['loanDocumentsForm', loanId],
              queryFn: () =>
                LoanService.getLoanDocuments({
                  loanId,
                  type: ['Insurance'],
                  unassociatedWithInsurance: true,
                  status: ['accepted', 'pending'],
                }),
              labelKey: (doc) =>
                `${doc.private_document?.name} ${
                  doc.description ? `- ${doc.description}` : ''
                }`,
              disabled: !loanId,
            },
            required: true,
          },
          {
            title: 'Type',
            name: 'type',
            type: 'select',
            options: [
              { value: 'declarations', label: 'Declarations' },
              { value: 'invoice', label: 'Invoice' },
              { value: 'binder', label: 'Binder' },
              { value: 'other', label: 'Other' },
              { value: 'rce', label: 'Replacement Cost Estimate' },
            ],
            required: true,
          },
        ],
      },
    ],
    [loanId]
  );

  return useForm({ fields, onSubmit: submitHandler });
};

export default useInsuranceDocumentForm;
